type ShouldShowAppliedPromotionsArgs = {
  flagEnabled: boolean;
  isCustomer: boolean;
  isPartner: boolean | undefined;
  userProfileLoading: boolean;
};

const shouldShowAppliedPromotions = ({
  flagEnabled,
  isCustomer,
  isPartner,
  userProfileLoading,
}: ShouldShowAppliedPromotionsArgs): boolean => {
  if (!flagEnabled) {
    return false;
  }

  if (isCustomer) {
    return true;
  }

  if (userProfileLoading) {
    return false;
  }

  return !isPartner;
};

export { shouldShowAppliedPromotions, type ShouldShowAppliedPromotionsArgs };
